import './styles/main.scss';

document.addEventListener('DOMContentLoaded', () => {
  const envelopeRight = document.getElementById('envelopRight') as HTMLElement;
  const envelopeLeft = document.getElementById('envelopLeft') as HTMLElement;
  const badge = document.getElementById('badge') as HTMLElement;
  const card = document.getElementById('card') as HTMLElement;
  const calendarBtn = document.getElementById('add-to-calendar') as HTMLElement;

  badge.addEventListener('click', () => {
    console.log("Clicked");
    if (envelopeRight.classList.contains('open') && envelopeLeft.classList.contains('open')) return; // prevent re-triggering

    // // Phase 1 – top flap folds open slowly (1.8 s)
    envelopeRight.classList.add('open');
    envelopeLeft.classList.add('open');
    card.classList.add('active');

    // // Phase 2 – entire envelope body slides down off-screen (1.3 s)
    setTimeout(() => card.classList.add('scroll'), 1150);

    // // Phase 3 – invitation card rises into view
    // setTimeout(() => card.classList.add('revealed'), 2150);

    // // Phase 4 – overlay background fades out completely
    // setTimeout(() => envelope.classList.add('opened'), 3500);
  });

  calendarBtn.addEventListener('click', () => addToCalendarUniversal());
});

function addToCalendarUniversal() {
  const title = "Siva Prasad & Gnanasoundarya Wedding Reception";
  const description = "Joyfully invite you to celebrate their wedding reception";
  const location = "Jawaharlal Saroja Thirumana Mahal, Thanakkankulam, Madurai";

  // May 18 2026, 18:30 IST → UTC is 13:00
  const startDate = "20260518T130000Z";
  const endDate   = "20260518T160000Z";

  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  if (isIOS) {
    // iOS → download ICS (best compatibility)
    const icsContent = [
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      "BEGIN:VEVENT",
      `SUMMARY:${title}`,
      `DESCRIPTION:${description}`,
      `LOCATION:${location}`,
      `DTSTART:${startDate}`,
      `DTEND:${endDate}`,
      "END:VEVENT",
      "END:VCALENDAR",
    ].join("\r\n");

    const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" });

    // Navigating to the blob URL causes iOS Safari to recognise the
    // text/calendar MIME type and open the native "Add to Calendar" dialog
    window.location.href = URL.createObjectURL(blob);

  } else {
    // Android / Desktop → Google Calendar
    const googleUrl =
      `https://calendar.google.com/calendar/render?action=TEMPLATE` +
      `&text=${encodeURIComponent(title)}` +
      `&dates=${startDate}/${endDate}` +
      `&details=${encodeURIComponent(description)}` +
      `&location=${encodeURIComponent(location)}`;

    window.open(googleUrl, "_blank");
  }
}

